import { createContext } from "react";
import { IOrderQuery } from "../../models/order/query";
import {IOrder, IOrderDetails, IOrderShort, IRatedOrder} from "../../models/order/response";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../utils/helpers/constants";
import { IMarkAccountingFinishedRequest, Update } from "../../models/order/request";
import { IUpdateOrderCustomerSatisfactionRequest } from "../../models/customer-satisfaction/request";

export type OrderLoading =
  | "list"
  | "details"
  | "create"
  | "update"
  | "delete"
  | "confirm_payment"
  | "mark_accounting_finished"
  | "customer_satisfaction";

export interface IInternalState {
  loading: OrderLoading[];

  list?: IBaseListingResponse<IOrder>;
  listShort?: IBaseListingResponse<IOrderShort>;
  listRated?: IBaseListingResponse<IRatedOrder>;
  query: IOrderQuery;

  details?: IOrderDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDataShort: () => void;
    getDataRated: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: IOrderDetails) => void;
    updateOrder: (id: number, data?: Update) => void;
    confirmPayment: (id: number) => void;
    markAccountingFinished: (
      id: number,
      data: IMarkAccountingFinishedRequest,
    ) => void;
    updateCustomerSatisfaction: (
      id: number,
      data: IUpdateOrderCustomerSatisfactionRequest,
    ) => void;
    exportExcel: (data: any) => any;

    setSearch: (search?: string) => void;
    setQuery: (query: IOrderQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDataShort: DEFAULT_FUNCTION,
    getDataRated: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    exportExcel: DEFAULT_FUNCTION,
    updateOrder: DEFAULT_FUNCTION,
    confirmPayment: DEFAULT_FUNCTION,
    markAccountingFinished: DEFAULT_FUNCTION,
    updateCustomerSatisfaction: DEFAULT_FUNCTION,
    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const OrderContext = createContext(externalState);

export default OrderContext;
